var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvalanche(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.444 0H29.556C32.3259 0 34.9824 1.10035 36.941 3.05898C38.8997 5.01761 40 7.67408 40 10.444V29.556C40.0001 30.9276 39.7301 32.2857 39.2053 33.5529C38.6805 34.8201 37.9112 35.9715 36.9413 36.9413C35.9715 37.9112 34.8201 38.6805 33.5529 39.2053C32.2857 39.7301 30.9276 40.0001 29.556 40H10.444C9.07244 40.0001 7.71428 39.7301 6.4471 39.2053C5.17991 38.6805 4.02852 37.9112 3.05868 36.9413C2.08884 35.9715 1.31955 34.8201 0.794735 33.5529C0.269921 32.2857 -0.000131249 30.9276 4.78531e-08 29.556V10.444C4.78531e-08 7.67408 1.10035 5.01761 3.05898 3.05898C5.01761 1.10035 7.67408 0 10.444 0ZM27.9326 21.4994C27.3214 20.4557 26.335 20.4557 25.7238 21.4994L21.8478 28.1049C21.2504 29.1486 21.7506 30 22.9592 30H30.6277C31.8503 30 32.3504 29.1486 31.7391 28.1049L27.9326 21.4994ZM20.5558 8.78277C19.9446 7.73908 18.9721 7.73908 18.3608 8.78277L7.26088 28.1049C6.64962 29.1623 7.14974 30 8.37227 30H13.9431C15.0684 29.9313 16.0825 29.3408 16.6938 28.407L23.4037 16.9126C23.89 15.9238 23.89 14.7566 23.4037 13.7678L21.4032 10.2934L20.5558 8.78277Z",
    fill: "#FFFFFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvalanche);
export default __webpack_public_path__ + "static/media/avalanche.1a11e30cfe15b422edb005a07ea14cc3.svg";
export { ForwardRef as ReactComponent };